import { MessageTemplateModalModel } from '../messageTemplateSamples/MessageTemplateModalModel';
import { MessageTemplateContentTypes } from './CreateMessageTemplateSidebarController';
export class MessageTemplateModalBuilder {
    static $inject = ['config'];
    constructor(config) {
        this.config = config;
        this.modalOptions = new MessageTemplateModalModel();
    }
    async build() {
        this.configureBaseModal();
        this.configureModalVariables();
        this.configureModalButtons();
        if (this.config.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
            await this.configurePaymentModal();
        }
        if (this.config.messageTemplateType === MessageTemplateContentTypes.CAROUSEL) {
            this.configureCarouselModal();
        }
        await this.configureModalCallbacks();
        return this.modalOptions;
    }
    configureBaseModal() {
        const firstTranslation = this.config.messageTemplate.translations[0];
        const { video, image, document } = this.config.mediaLinks;
        this.modalOptions.body = firstTranslation.text;
        this.modalOptions.type = this.config.messageTemplateType;
        this.modalOptions.uri = video ?? image ?? document;
        this.modalOptions.preview = true;
    }
    configureModalVariables() {
        const text = this.config.messageTemplate.translations[0].text;
        this.modalOptions.variables = this.config.variableExtractors.getText(text);
    }
    configureModalButtons() {
        const buttons = this.config.messageTemplate.translations[0].buttons;
        this.modalOptions.buttonsVariables = this.config.variableExtractors.getButtons();
        this.modalOptions.buttons = buttons?.length ? buttons : [];
    }
    async configurePaymentModal() {
        if (!this.config.paymentExtractors) {
            return;
        }
        this.modalOptions.displayFormat = 'order_details';
        const firstTranslation = this.config.messageTemplate.translations[0];
        const currentHeaderText = this.config.paymentExtractors.getHeaderValue() ??
            firstTranslation.headerText;
        const currentFooterText = this.config.paymentExtractors.getFooterValue() ??
            firstTranslation.footerText ??
            '';
        const paymentSettings = this.config.paymentExtractors.getSettings();
        this.configurePaymentHeader(currentHeaderText, paymentSettings);
        this.configurePaymentFooter(currentFooterText);
        this.configurePaymentMedia(paymentSettings);
    }
    configurePaymentHeader(currentHeaderText, paymentSettings) {
        if (paymentSettings.headerType === 'text' && currentHeaderText) {
            this.modalOptions.headerText = currentHeaderText;
            this.modalOptions.headerVariables = this.config.variableExtractors.getText(currentHeaderText);
        }
        else {
            this.modalOptions.headerText = '';
            this.modalOptions.headerVariables = null;
        }
        this.modalOptions.headerType = paymentSettings.headerType;
    }
    configurePaymentFooter(currentFooterText) {
        if (currentFooterText) {
            this.modalOptions.footer = currentFooterText;
            this.modalOptions.footerText = currentFooterText;
        }
    }
    configurePaymentMedia(paymentSettings) {
        if (!this.config.paymentExtractors) {
            return;
        }
        const currentPaymentSettings = this.config.paymentExtractors.getSettings();
        this.modalOptions.showFooter = currentPaymentSettings.showFooter;
        this.modalOptions.imageLink = paymentSettings.imageLink;
        this.modalOptions.documentLink = paymentSettings.documentLink;
    }
    configureCarouselModal() {
        const firstTranslation = this.config.messageTemplate.translations[0];
        this.modalOptions.variables = firstTranslation.bodyTextVariables ?? [];
        this.modalOptions.cardsVariables = firstTranslation.cardVariables ?? [];
        this.modalOptions.body = firstTranslation.bodyText ?? '';
        this.modalOptions.cards = firstTranslation.cards ?? [];
        this.modalOptions.cardButtonVariables = firstTranslation.cardButtonVariables ?? [];
    }
    async configureModalCallbacks() {
        this.modalOptions.confirmBtn = await this.config.translateService('utils.forms.confirm');
        this.modalOptions.cancelBtn = await this.config.translateService('utils.forms.cancel');
        this.modalOptions.onConfirm = (bodyVariables, buttonVariables, headerVariables, carouselCardVariables, cardButtonVariables) => {
            this.config.callbacks.onSave({
                bodyVariables,
                buttonVariables,
                headerVariables,
                carouselCardVariables,
                cardButtonVariables,
            });
        };
        this.modalOptions.onCancel = () => this.config.callbacks.onCancel();
        this.modalOptions.matchVariables = (text) => this.config.variableExtractors.getText(text);
    }
}
MessageTemplateModalBuilder.$inject = ['config'];
